export default {
  NAME: "SchedulingPlatforms.com",
  SUPPORT_EMAIL: "brian@gorham.com",
};
